import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, X } from 'lucide-react';
const NAMES = ['Sofía G.', 'Martín P.', 'Valentina R.', 'Lucía M.', 'Mateo F.', 'Camila S.', 'Julián D.', 'Agustina L.', 'Florencia B.', 'Tomás A.', 'Micaela V.', 'Nicolás C.', 'Carolina T.', 'Federico H.', 'Rocío N.', 'Gabriela E.', 'Facundo Q.', 'Antonella Z.', 'Ramiro O.', 'Daniela I.'];
const CITIES = ['CABA, Buenos Aires', 'La Plata, Buenos Aires', 'Mar del Plata, Buenos Aires', 'Córdoba Capital', 'Rosario, Santa Fe', 'Santa Fe Capital', 'Mendoza Capital', 'San Miguel de Tucumán', 'Salta Capital', 'Neuquén Capital', 'San Carlos de Bariloche', 'Posadas, Misiones', 'Resistencia, Chaco', 'San Juan Capital', 'Paraná, Entre Ríos', 'Bahía Blanca, Buenos Aires', 'Corrientes Capital', 'San Salvador de Jujuy'];
const OFFERS = ['el Megapack PRO', 'la Edición Total'];
interface Purchase {
  name: string;
  city: string;
  offer: string;
  minutesAgo: number;
}
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function buildPurchase(): Purchase {
  return {
    name: randomItem(NAMES),
    city: randomItem(CITIES),
    offer: randomItem(OFFERS),
    minutesAgo: Math.floor(Math.random() * 9) + 1
  };
}
const VISIBLE_MS = 6500;
const INITIAL_DELAY_MS = 5000;
const minGapMs = 40000;
const maxGapMs = 60000;
export function PurchaseNotification() {
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    const clearAll = () => {
      timers.current.forEach(t => window.clearTimeout(t));
      timers.current = [];
    };
    const scheduleHide = () => {
      const hideTimer = window.setTimeout(() => {
        setPurchase(null);
        scheduleShow();
      }, VISIBLE_MS);
      timers.current.push(hideTimer);
    };
    const scheduleShow = () => {
      const gap = Math.floor(Math.random() * (maxGapMs - minGapMs)) + minGapMs;
      const showTimer = window.setTimeout(() => {
        setPurchase(buildPurchase());
        scheduleHide();
      }, gap);
      timers.current.push(showTimer);
    };
    // First notification after a short initial delay
    const initialTimer = window.setTimeout(() => {
      setPurchase(buildPurchase());
      scheduleHide();
    }, INITIAL_DELAY_MS);
    timers.current.push(initialTimer);
    return clearAll;
  }, []);
  const handleClose = () => setPurchase(null);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-15">
      <AnimatePresence data-id="element-16">
        {purchase && <motion.div role="status" aria-live="polite" initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto relative w-[300px] max-w-[calc(100vw-2rem)] bg-white rounded-xl shadow-xl border border-slate-200 p-3 pr-8 flex items-start gap-3" data-id="element-17">
            <button type="button" onClick={handleClose} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-slate-300 hover:text-slate-500 transition-colors" data-id="element-18">
              <X className="w-4 h-4" data-id="element-19" />
            </button>

            <span className="flex-shrink-0 w-10 h-10 bg-green-50 text-green-600 rounded-full flex items-center justify-center" data-id="element-20">
              <BadgeCheck className="w-6 h-6" data-id="element-21" />
            </span>

            <div className="min-w-0" data-id="element-22">
              <div className="flex items-center gap-1.5 mb-0.5" data-id="element-23">
                <span className="text-[11px] font-bold text-green-600 uppercase tracking-wide" data-id="element-24">
                  Compra verificada
                </span>
              </div>
              <p className="text-sm text-slate-800 leading-snug" data-id="element-25">
                <strong className="font-semibold" data-id="element-26">{purchase.name}</strong> de{' '}
                {purchase.city} compró {purchase.offer}.
              </p>
              <p className="text-[11px] text-slate-400 mt-0.5" data-id="element-27">
                Hace {purchase.minutesAgo}{' '}
                {purchase.minutesAgo === 1 ? 'minuto' : 'minutos'} · Pago con
                Mercado Pago
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}